import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './FilterButtonGroup.module.scss';
export interface FilterOption {
  value: string;
  label: string;
  icon?: ReactNode;
}
export type FilterButtonGroupVariant = 'pill' | 'checklist';
export interface FilterButtonGroupProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
  variant?: FilterButtonGroupVariant;
}
function FilterButtonGroup(t0) {
  const $ = _c(16);
  const {
    options,
    value,
    onChange,
    ariaLabel: t1,
    variant: t2
  } = t0;
  const ariaLabel = t1 === undefined ? "Filter options" : t1;
  const variant = t2 === undefined ? "pill" : t2;
  const isChecklist = variant === "checklist";
  const t3 = styles[`helios-filter-group--${variant}`];
  let t4;
  if ($[0] !== t3) {
    t4 = classNames(styles["helios-filter-group"], t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = isChecklist ? "radiogroup" : "group";
  let t6;
  if ($[2] !== isChecklist || $[3] !== onChange || $[4] !== options || $[5] !== value) {
    let t7;
    if ($[7] !== isChecklist || $[8] !== onChange || $[9] !== value) {
      t7 = option => <button key={option.value} type="button" className={classNames(styles["helios-filter-group__btn"], {
        [styles["helios-filter-group__btn--active"]]: value === option.value
      })} onClick={() => onChange(option.value)} role={isChecklist ? "radio" : undefined} aria-checked={isChecklist ? value === option.value : undefined} aria-pressed={isChecklist ? undefined : value === option.value}>{option.icon && <span className={styles["helios-filter-group__btn-icon"]} aria-hidden="true">{option.icon}</span>}{option.label}</button>;
      $[7] = isChecklist;
      $[8] = onChange;
      $[9] = value;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = options.map(t7);
    $[2] = isChecklist;
    $[3] = onChange;
    $[4] = options;
    $[5] = value;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[11] !== ariaLabel || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t4} role={t5} aria-label={ariaLabel}>{t6}</div>;
    $[11] = ariaLabel;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
export default FilterButtonGroup;